export interface PrinterPort extends EventTarget {
  writable: WritableStream<Uint8Array> | null
  open(options: { baudRate: number }): Promise<void>
  close(): Promise<void>
}

interface PrinterSerial {
  requestPort(): Promise<PrinterPort>
  getPorts(): Promise<PrinterPort[]>
}

export function getPrinterSerial(): PrinterSerial | undefined {
  return (navigator as Navigator & { serial?: PrinterSerial }).serial
}

export async function writePrintJob(port: PrinterPort, commands: Uint8Array): Promise<void> {
  if (!port.writable) throw new Error('Stampante non connessa')
  const writer = port.writable.getWriter()
  let cancelled = false
  let timer: ReturnType<typeof setTimeout> | undefined
  const expired = new Promise<never>((_, reject) => {
    timer = setTimeout(() => {
      cancelled = true
      reject(new Error('Tempo di invio alla stampante scaduto'))
    }, 20000)
  })
  try {
    await Promise.race([
      (async () => {
        for (let offset = 0; offset < commands.length; offset += 512) {
          if (cancelled) throw new Error('Invio annullato')
          await writer.write(commands.slice(offset, offset + 512))
          await new Promise(resolve => setTimeout(resolve, 20))
        }
      })(),
      expired,
    ])
  } catch (error) {
    cancelled = true
    void writer.abort(error).catch(() => {})
    throw error
  } finally {
    clearTimeout(timer)
    writer.releaseLock()
  }
}
